import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\ManageItemStockDossierController::__invoke
* @see app/Http/Controllers/Dossier/ManageItemStockDossierController.php
* @route '/api/dossier/{dossier}/manage-items-stock'
*/
const ManageItemStockDossierController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ManageItemStockDossierController.url(args, options),
    method: 'post',
})

ManageItemStockDossierController.definition = {
    methods: ["post"],
    url: '/api/dossier/{dossier}/manage-items-stock',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\ManageItemStockDossierController::__invoke
* @see app/Http/Controllers/Dossier/ManageItemStockDossierController.php
* @route '/api/dossier/{dossier}/manage-items-stock'
*/
ManageItemStockDossierController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return ManageItemStockDossierController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\ManageItemStockDossierController::__invoke
* @see app/Http/Controllers/Dossier/ManageItemStockDossierController.php
* @route '/api/dossier/{dossier}/manage-items-stock'
*/
ManageItemStockDossierController.post = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ManageItemStockDossierController.url(args, options),
    method: 'post',
})

export default ManageItemStockDossierController